import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { trackLead } from '../lib/metaPixel';
export function ClientRatings() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-ocean-dark text-white" data-id="element-30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-32">
          <div className="flex items-center justify-center gap-1 mb-4 text-turquoise" aria-label="Five stars" data-id="element-33">
            {Array.from({
            length: 5
          }).map((_, index) => <Star key={index} size={22} fill="currentColor" aria-hidden="true" data-id="element-34" />)}
          </div>
          <h2 className="text-4xl font-heading font-bold mb-4" data-id="element-35">
            {t.clientRatings.title}
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto mb-10" data-id="element-36">
            {t.clientRatings.subtitle}
          </p>
        </motion.div>

        <motion.a href="https://share.google/tMvaYTA2Yu5t2ZAyC" target="_blank" rel="noreferrer" onClick={trackLead} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} whileHover={{
        scale: 1.04
      }} className="inline-flex items-center justify-center gap-2 bg-turquoise hover:bg-turquoise-light text-white px-8 py-4 rounded-full font-semibold text-lg transition-colors shadow-[0_0_20px_rgba(0,180,216,0.4)] w-full sm:w-auto focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white" data-id="element-37">
          <Star size={20} data-id="element-38" />
          {t.clientRatings.bluOcean}
        </motion.a>
      </div>
    </section>;
}